import EventBillCollection from './event_bill_collection';
export default Backbone.Model.extend({
  parse: function (response) {
    var data = response;
    if (response.bills) {
      data.bills = new EventBillCollection(response.bills);
    }
    return data;
  }
});